import React, { useCallback, useEffect, useState } from 'react';
import { Trash2, Plus } from 'lucide-react';
import { api, useAuth } from '../../context/AuthContext';
import { Btn, inp, fmt, fehler, Meldung } from './ui';
import { DatumFeld } from '../DatumFeld';

export const dauer = (min) => `${Math.floor(min / 60)} Std. ${String(min % 60).padStart(2, '0')} Min.`;
const heute = () => new Date().toLocaleDateString('sv-SE', { timeZone: 'Europe/Berlin' });

export const Zeitkonto = ({ cid, mnr }) => {
  const { user } = useAuth();
  const [d, setD] = useState(null);
  const [f, setF] = useState({ datum: heute(), minuten: '', beschreibung: '' });
  const [msg, setMsg] = useState('');
  const load = useCallback(() => api.get('/kanzlei/zeitkonto', { params: cid ? { case_id: cid } : { mnr } }).then((r) => setD(r.data)).catch(() => setD({ items: [], summe_minuten: 0 })), [cid, mnr]);
  useEffect(() => { load(); }, [load]);
  const add = async () => { setMsg(''); try { await api.post('/kanzlei/zeitkonto', { ...f, minuten: Number(f.minuten), case_id: cid || null, mandanten_nr: mnr }); setF({ datum: heute(), minuten: '', beschreibung: '' }); setMsg('Zeit nachgetragen'); load(); } catch (e) { setMsg(fehler(e)); } };
  const weg = async (id) => { setMsg(''); try { await api.delete(`/kanzlei/zeitkonto/${id}`); load(); } catch (e) { setMsg(fehler(e)); } };
  if (!d) return null;
  return (
    <div className="space-y-2" data-testid={`zeitkonto-${cid || mnr}`}>
      <p className="text-sm text-[#1B3A5C]">Gesamt: <b data-testid="zeitkonto-summe">{dauer(d.summe_minuten)}</b> <span className="text-xs text-[#7a8a99]">· Grundlage für das Zeithonorar</span></p>
      <ul className="divide-y divide-gray-50 text-sm">
        {d.items.map((z) => (
          <li key={z.id} className="flex flex-wrap items-center gap-2 py-1.5" data-testid={`zeit-${z.id}`}>
            <span className="w-24 text-[#7a8a99]">{fmt(z.datum)}</span>
            <span className="flex-1 min-w-0 break-words text-[#1B3A5C]">{z.beschreibung}<span className="block text-[11px] text-gray-500">{z.von?.name} · {z.quelle === 'gespraech' ? 'Stoppuhr' : 'von Hand'}</span></span>
            <span className="font-mono text-[#1B3A5C]">{z.minuten} Min.</span>
            {z.quelle === 'hand' && (z.von?.user_id === user?.user_id || user?.role === 'admin') && <button type="button" onClick={() => weg(z.id)} className="text-rose-600" aria-label="Löschen" data-testid={`zeit-weg-${z.id}`}><Trash2 className="w-4 h-4" /></button>}
          </li>
        ))}
        {!d.items.length && <li className="text-xs text-gray-400 py-2">Noch keine Zeiten erfasst.</li>}
      </ul>
      <div className="grid grid-cols-2 sm:grid-cols-[9rem_6rem_1fr_auto] gap-2">
        <DatumFeld value={f.datum} onChange={(v) => setF({ ...f, datum: v })} className={inp} testId="zeit-datum" />
        <input type="number" min="1" max="1440" value={f.minuten} onChange={(e) => setF({ ...f, minuten: e.target.value })} placeholder="Minuten" className={inp} data-testid="zeit-minuten" />
        <input value={f.beschreibung} onChange={(e) => setF({ ...f, beschreibung: e.target.value })} placeholder="Tätigkeit, z. B. Aktenstudium" className={`${inp} col-span-2 sm:col-span-1`} data-testid="zeit-beschreibung" />
        <Btn variant="navy" onClick={add} disabled={!f.minuten || !f.beschreibung.trim()} testId="zeit-nachtragen"><Plus className="w-3 h-3" />Nachtragen</Btn>
      </div>
      <Meldung text={msg} testId="zeit-msg" />
    </div>
  );
};

export default Zeitkonto;
